import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { useToast } from '../hooks/use-toast';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { toast } = useToast();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setShowSuccess(true);
        toast({
          title: "✅ Message Sent Successfully!",
          description: "Thank you for contacting us. We'll get back to you as soon as possible at " + formData.email,
          duration: 5000,
        });
        setFormData({ name: '', email: '', message: '' });
        
        // Hide success message after 10 seconds
        setTimeout(() => {
          setShowSuccess(false);
        }, 10000);
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to send message. Please email us directly at support@umenuhub.com",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-header">
        <h2>Questions or Need Support?</h2>
        <p>Fill out the form below or email us directly at <a href="mailto:support@umenuhub.com">support@umenuhub.com</a></p>
      </div>

      {showSuccess && (
        <div className="success-banner">
          <div className="success-content">
            <span className="success-icon">✅</span>
            <div className="success-text">
              <h3>Message Sent Successfully!</h3>
              <p>Thank you for contacting us. We'll get back to you as soon as possible.</p>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <Input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Your name"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <Input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="your.email@example.com"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <Textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            placeholder="How can we help you?"
            className="form-textarea"
            rows={5}
          />
        </div>

        <Button 
          type="submit" 
          disabled={isSubmitting}
          className="submit-button"
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </Button>
      </form>

      <div className="business-address">
        <h3>Principal Place of Business</h3>
        <address>
          uMenu LLC<br />
          1309 Coffeen Avenue STE 1200<br />
          Sheridan, Wyoming 82801
        </address>
      </div>
    </div>
  );
};

export default ContactForm;
